import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-section-about8',
  templateUrl: './section-about8.component.html',
  styleUrls: ['./section-about8.component.css']
})
export class SectionAbout8Component implements OnInit {

  @Input() data: any;
  
  constructor() { }

  ngOnInit(): void {
  }

}
